import InputGroupAutocomplete from './InputGroupAutocomplete';
import { InputSelectContextProvider } from './context/InputSelectContext';
import { FieldProps } from './types';

const InputSelect = (props: FieldProps) => {
	return (
		<InputSelectContextProvider>
			<InputGroupAutocomplete {...props} />
		</InputSelectContextProvider>
	);
};

export default InputSelect;
